<template>
    <div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group fv-plugins-icon-container">
                    <label>{{ __('store.name') }}</label>
                    <multiselect
                        v-model="store"
                        track-by="id"
                        label="id"
                        :limit="10"
                        :internal-search="false"
                        :limit-text="limitText"
                        :options="stores"
                        :loading="loading"
                        :show-labels="false"
                        @select="storeSelected"
                        @search-change="asyncFind">
                        <template slot="singleLabel" slot-scope="props">
                            <div v-if="store.id">
                                <div>{{ props.option.attributes.name }} <span
                                    class="text-muted font-size-sm">{{ props.option.attributes.address.street1 }}</span>
                                </div>
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                        <template slot="option" slot-scope="props">
                            <div class="d-flex">
                                <img width="80" height="40" :src="props.option.logo" alt="" class="mr-3">
                                <div>
                                    <div>{{ props.option.attributes.name }}</div>
                                    <div class="font-size-sm mt-1 opacity-75">
                                        {{ props.option.attributes.address.street1 }},
                                        {{ props.option.attributes.address.postcode }} {{
                                            props.option.attributes.address.city
                                        }},
                                    </div>
                                </div>
                            </div>
                        </template>
                    </multiselect>
                    <span class="form-text text-muted">Geben Sie den Namen des Geschäfts ein</span>
                    <div class="fv-plugins-message-container"></div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group fv-plugins-icon-container">
                    <label>{{ __('store.city') }}</label>
                    <input type="text" class="form-control form-control-lg" v-model="city"
                           :placeholder="__('store.city')">
                    <span class="form-text text-muted">Geben Sie einen Stadtnamen ein um die Suche einzugrenzen</span>
                    <div class="fv-plugins-message-container"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {debounce} from '@composables/debounce'

export default {
    components: {
        Multiselect,
    },

    props: {
        value: Object
    },

    data() {
        return {
            loading: false,
            store: {},
            city: '',
            stores: [],
        }
    },

    mounted() {
        this.store = this.value
    },

    methods: {
        storeSelected(store){
            this.$emit('input', store)
        },

        limitText(count) {
            return this.__('store.n_more_stores', {count: count})
        },

        asyncFind: debounce(function(query) {
            if (query.trim().length === 0) {
                this.stores = []
                return
            }

            this.loading = true
            axios.get(this.$route('stores.find-existing', {
                name: query,
                city: this.city,
            })).then(response => {
                this.stores = response.data.data
                this.loading = false
            })
        }, 350),
    },
}
</script>
